import * as Api from '../../api/axiosCoreConfig';

export const searchResult = (body) => Api.Post('form/f/search', body);
export const getSearchReport = (namespace) =>
    Api.Get(`form/f/search/exports/?namespace=${namespace}`);
export const createSearchReport = (reqBody) => Api.Post('form/f/search/exports', reqBody);
export const deleteSearchReport = (exportId, namespace) =>
    Api.Delete(`form/f/search/exports/${exportId}/?namespace=${namespace}`);
